import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import BackgroundImage from '../assets/background1.jpg'; // Import your background image
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHardHat,
  faTruckFast,
  faIndustry,
  faAward,
  faUserTie,
  faHeadset,
} from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';


// Keyframes for animations
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Styled components for the Home page
const HomeContainer = styled.div`
  text-align: center;
  padding: 20px;
`;

const HeroSection = styled.section`
  padding: 100px 20px;
  margin: 20px 0;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${BackgroundImage});
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 500px; /* Increased height for more impact */
  overflow: hidden;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  animation: ${fadeIn} 1s ease-out;
  color: white;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Text = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  animation: ${fadeIn} 1.5s ease-out;
  color: #2089ac;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Button = styled.button`
  background-color: #2089ac; /* Use the specified color */
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  z-index: 1;
  animation: ${fadeIn} 2s ease-out;
  margin-top: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Section = styled.section`
  padding: 40px 20px;
  margin: 20px 0;
  background-color: ${({ bgColor }) => bgColor || '#f9f9f9'};
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Subtitle = styled.h2`
  font-size: 2rem;
  color: white; /* White subtitles */
  margin-bottom: 15px;
  background-color: #2089ac; /* Use the specified color */
  padding: 10px 20px;
  border-radius: 5px;
  display: inline-block;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const Card = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 10px;
`;

const CardText = styled.p`
  font-size: 1rem;
  color: #555;
`;

const Icon = styled.div`
  font-size: 2.5rem;
  color: #2089ac; /* Use the specified color */
  margin-bottom: 15px;
`;

const TextH = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  animation: ${fadeIn} 1.5s ease-out;
  color: white;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;



const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleWhatsAppClick = () => {
    const phoneNumber = '+212661497628';
    const message = encodeURIComponent('Bonjour, je souhaite vous contacter à propos de vos services de silice.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  const handleGmailClick = () => {
    const email = 'anejjarider@gmail.com';
    const subject = encodeURIComponent('Demande de renseignements');
    const body = encodeURIComponent('Bonjour, je souhaite vous contacter à propos de vos services de silice.');
    window.open(`mailto:${email}?subject=${subject}&body=${body}`, '_blank');
  };

  return (
    <HomeContainer>
      {/* Hero Section with Background Image */}
      <HeroSection>
        <Title>Bienvenue chez LES MINES D'AMEZMIZ</Title>
        <TextH>
          Votre partenaire de confiance pour la fourniture de silice de haute qualité au Maroc.
        </TextH>
        <Button onClick={() => setIsModalOpen(true)}>Contactez-nous</Button>
      </HeroSection>

      {/* Modal for Contact Options */}
      {isModalOpen && (
        <Modal
          onClose={() => setIsModalOpen(false)}
          onWhatsAppClick={handleWhatsAppClick}
          onGmailClick={handleGmailClick}
        />
      )}

	   {/* Services Section */}
	   <Section>
        <Subtitle>Nos Services</Subtitle>
        <Text>
          Nous offrons une gamme complète de services pour répondre à vos besoins en silice.
        </Text>
        <Grid>
          <Card>
            <Icon>
              <FontAwesomeIcon icon={faHardHat} />
            </Icon>
            <CardTitle>Extraction de Silice</CardTitle>
            <CardText>
              Nous extrayons et traitons la silice avec soin pour garantir une qualité optimale.
            </CardText>
          </Card>
          <Card>
            <Icon>
              <FontAwesomeIcon icon={faTruckFast} />
            </Icon>
            <CardTitle>Livraison Rapide</CardTitle>
            <CardText>
              Nous livrons en vrac, en sacs ou en big bags, selon vos besoins.
            </CardText>
          </Card>
          <Card>
            <Icon>
              <FontAwesomeIcon icon={faIndustry} />
            </Icon>
            <CardTitle>Applications Diverses</CardTitle>
            <CardText>
              Notre silice est utilisée dans la construction, la filtration, la verrerie, et plus encore.
            </CardText>
          </Card>
        </Grid>
      </Section>

      {/* Why Choose Us Section */}
      <Section bgColor="#ecf0f1">
        <Subtitle>Pourquoi Nous Choisir ?</Subtitle>
        <Text>
          Découvrez les raisons pour lesquelles nous sommes le leader dans la fourniture de silice.
        </Text>
        <Grid>
          <Card>
            <Icon>
              <FontAwesomeIcon icon={faAward} />
            </Icon>
            <CardTitle>Qualité Inégalée</CardTitle>
            <CardText>
              Notre silice est testée et certifiée pour répondre aux normes les plus strictes.
            </CardText>
          </Card>
          <Card>
            <Icon>
              <FontAwesomeIcon icon={faUserTie} />
            </Icon>
            <CardTitle>Expérience et Expertise</CardTitle>
            <CardText>
              Avec des années d'expérience, nous maîtrisons parfaitement l'extraction et le traitement de la silice.
            </CardText>
          </Card>
          <Card>
            <Icon>
              <FontAwesomeIcon icon={faHeadset} />
            </Icon>
            <CardTitle>Service Client Personnalisé</CardTitle>
            <CardText>
              Nous nous adaptons à vos besoins pour vous offrir la meilleure solution.
            </CardText>
          </Card>
        </Grid>
      </Section>
    </HomeContainer>
  );
};

export default Home;
